import FantasyCoefficientsModel from "./FantasyCoefficientsModel";
import FantasyMultipliersModel from "./FantasyMultipliersModel";
import FantasyPlayersModel from "./FantasyPlayersModel";

export default class FantasyConfigModel {
  public enabled: boolean = false;
  public clientId: string = null;
  public addPointsToProfileTotal: boolean = false;
  public coefficients: FantasyCoefficientsModel =
    new FantasyCoefficientsModel();
  public players: FantasyPlayersModel = new FantasyPlayersModel();
  public multipliers: FantasyMultipliersModel = null
  public competitionsWhitelist: string[] = [];
}
